import { render } from "./NoWallet.vue?vue&type=template&id=3499b043&scoped=true"
import script from "./NoWallet.vue?vue&type=script&lang=js"
export * from "./NoWallet.vue?vue&type=script&lang=js"

import "./NoWallet.vue?vue&type=style&index=0&id=3499b043&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3499b043"]])

export default __exports__